import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "removed",
  "use": "removed-usage",
  "viewBox": "0 0 41 41",
  "content": "<symbol viewBox=\"0 0 41 41\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"removed\">\n<line x1=\"36.8174\" y1=\"3.52846\" x2=\"3.52874\" y2=\"36.8171\" stroke=\"currentColor\" stroke-width=\"4.99\" stroke-linecap=\"round\" />\n<line x1=\"2.495\" y1=\"-2.495\" x2=\"49.5723\" y2=\"-2.495\" transform=\"matrix(0.707107 0.707107 0.707107 -0.707107 3.80566 0.863739)\" stroke=\"currentColor\" stroke-width=\"4.99\" stroke-linecap=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol